module.exports = __webpack_public_path__ + "static/media/proofpoint-logo-white.b5660f1e.svg";